<template>
  <div>
    <div class="block">
      <b-switch v-model="mobileSize"> 携帯サイズで表示</b-switch>
    </div>

    <div
      style="background-color: #f4f4f4; padding: 10px 15px; border-radius: 5px; margin: 0 auto;"
      :style="{width: mobileSize ? '360px' : 'auto'}"
    >
      <h1 class="title">{{ survey.title }}</h1>
      <div class="subtitle">{{ survey.description }}</div>

      <div style="margin-top: 20px;">
        <div
          v-for="question in survey.questions"
          :key="question.id"
          style="margin-bottom: 20px;"
        >
          <div class="is-size-5" style="font-weight: bold;">{{ question.title }} <span v-if="question.validation_required" class="has-text-danger">*</span></div>

          <div v-if="question.guide_text_enabled"> {{question.guide_text }} </div>

          <div v-if="question.type == 'text' || question.type == 'textarea'">
            <b-input :type="question.type" :name="question.id"/>
          </div>

          <div v-if="question.type == 'radio' || question.type == 'checkbox'">
            <div v-for="option in question.options" :key="option.id">
              <div class="field">
                <div :is="`b-${question.type}`" v-model="question.id" :name="question.id" :value="option.title">{{ option.title }}</div>
              </div>
              <div class="field" v-if="option.require_text_input" style="margin-bottom: 10px;">
                <b-input :placeholder="option.title + 'を選んだ場合'"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['survey'],

  data() {
    return {
      mobileSize: false,
    }
  },

  computed: {
    id() {
      return this.$route.params.id
    }
  },
}
</script>
